var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TopBarControlWrapper',[_c('AppButtonIcon',{attrs:{"icon":_vm.buttonIcon,"button-style":_vm.buttonStyle,"size":_vm.size},nativeOn:{"click":function($event){return _vm.$emit('button-click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }